import { Injectable } from '@angular/core';
import { RateLimitQueue, Rates } from '@eg-brs/eg.js.ratelimit';

@Injectable({
  providedIn: 'root'
})
export class RateLimitService {
  public queue = new RateLimitQueue();

  public static readonly RATE_LIMITS = 'ratelimits';

  constructor() {
    const rates = JSON.parse(sessionStorage.getItem(RateLimitService.RATE_LIMITS)) as Rates;
    if(rates != null) {
      this.queue.rates = rates;
    }

    this.queue.onChange = () => {
      sessionStorage.setItem(RateLimitService.RATE_LIMITS, JSON.stringify(this.queue.rates));
    };
  }
}
